const appBar = (tokens) => {
    const { appBar } = tokens.component;
    return {
        MuiAppBar: {
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign({ minHeight: appBar.minHeight.value }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "primary" && {
                    backgroundColor: appBar.backgroundColor.value,
                })), { "& .MuiToolbar-root": {
                        minHeight: appBar.minHeight.value,
                    } })),
            },
        },
    };
};
export default appBar;
//# sourceMappingURL=appBar.js.map